
export default {
  name: 'SvgPencilSquare',
  computed: {
    color() {
      return this.$store.state.theme === 'dark' ? '#E0E7EC' : '#1E1E23'
    },
  },
}
